import { useState, useEffect } from 'react'

export interface DeviceInfo {
    platform: string | undefined
}

const checkDeviceType = (device: string): string => {
    const isPwa = window.matchMedia('(display-mode: standalone)').matches

    const desktopDevices = ['Win32', 'MacIntel', 'Linux x86_64']
    const mobileDevices = {
        iPhone: 'iPhone',
        'Linux armv81': 'Android'
    }

    if (desktopDevices.includes(device)) {
        return isPwa ? 'Pwa' : 'Desktop'
    }

    if (device in mobileDevices) {
        return isPwa
            ? 'Pwa'
            : mobileDevices[device as keyof typeof mobileDevices]
    }

    if (device === 'pwa' || isPwa) {
        return 'Pwa'
    }

    return device
}

export const useDeviceInfo = (): DeviceInfo | null => {
    const [deviceInfo, setDeviceInfo] = useState<DeviceInfo | null>(null)

    useEffect(() => {
        setDeviceInfo({
            platform: checkDeviceType(navigator.platform)
        })
    }, [])

    return deviceInfo
}
